$('.who-for #sector').val('');

$('.who-for #sector').on('change', function () {
    $val = $(this).val();
    if ($val.length) {
        window.location.href = $val;
    }
});
